import React from 'react'
import { createIcon } from '@chakra-ui/react'

export const UserGroupBase = (
  <path
    fill='currentColor'
    d='M4.5 8.2c1.159 0 2.1-.94 2.1-2.1C6.6 4.94 5.658 4 4.5 4c-1.16 0-2.1.94-2.1 2.1 0 1.16.94 2.1 2.1 2.1zm7 0c1.159 0 2.1-.94 2.1-2.1 0-1.16-.941-2.1-2.1-2.1-1.16 0-2.1.94-2.1 2.1 0 1.16.94 2.1 2.1 2.1zM1 11c0-1.546 1.254-2.8 2.8-2.8h1.4C6.746 8.2 8 9.454 8 11H1zm7 0h7c0-1.546-1.254-2.8-2.8-2.8h-1.4C9.254 8.2 8 9.454 8 11z'
  />
)

export const UserGroup = createIcon({
  displayName: 'UserGroup',
  viewBox: '0 0 16 16',
  path: UserGroupBase,
})
